import { Formula } from './ai-math.jsx';
import { mathIsEscaped } from './ai-math-syntax.mjs';
import { StreamText } from './ai-stream.jsx';

export function safeLink(value) {
  try { const u = new URL(value); return ['http:', 'https:'].includes(u.protocol) && !u.username && !u.password ? u.href : null; } catch { return null; }
}

export function InlineMarkdown({ text = '', sources = [], onCitation, interactive = true }) {
  text = typeof text === 'string' ? text : typeof text === 'number' ? String(text) : '';
  const regex = /(\\[\\*`]|`[^`\n]+`|\*\*(?=\S)(?:(?!\*\*|\n\s*\n)[\s\S])+?\*\*|\\\([\s\S]+?\\\)|\$(?![\s$])[^$\n]*?[^\s$]\$(?![\d$])|\[[^\]\n]+\]\(https?:\/\/[^\s)]+\)|\[\d{1,2}\]|https?:\/\/[^\s<>\[\]`*（）()，。；！？、]+)/g;
  const nodes = []; let cursor = 0, match;
  while ((match = regex.exec(text))) {
    if (match.index > cursor) nodes.push(<StreamText key={'text-' + cursor} text={text.slice(cursor, match.index)}/>);
    const token = match[0], key = match.index;
    if (/^\\[\\*`]$/.test(token)) nodes.push(<StreamText key={key} text={token.slice(1)}/>);
    else if ((token.startsWith('\\(') || token.startsWith('$')) && !mathIsEscaped(text, match.index)) {
      const tex = token.startsWith('\\(') ? token.slice(2, -2) : token.slice(1, -1);
      nodes.push(<Formula key={key} tex={tex}/>);
    }
    else if (token.startsWith('`')) nodes.push(<code key={key}>{token.slice(1, -1)}</code>);
    else if (token.startsWith('**')) nodes.push(<strong key={key}><InlineMarkdown text={token.slice(2, -2)} sources={sources} onCitation={onCitation} interactive={interactive}/></strong>);
    else if (/^https?:\/\//.test(token)) {
      const clean = token.replace(/[.,;:!?]+$/, ''), url = safeLink(clean);
      nodes.push(url && interactive ? <a key={key} href={url} target="_blank" rel="noopener noreferrer">{clean}</a> : clean);
      if (clean.length < token.length) nodes.push(token.slice(clean.length));
    }
    else if (/^\[\d+\]$/.test(token)) {
      const id = Number(token.slice(1, -1)), source = Array.isArray(sources) ? sources.find(s => s?.id === id) : null;
      nodes.push(source && interactive && onCitation ? <button key={key} className="ai-citation" aria-label={'查看来源 ' + id + '：' + source.title} onClick={() => onCitation(id)}>{id}</button> : token);
    } else {
      const m = token.match(/^\[([^\]]+)\]\((.*)\)$/), url = safeLink(m?.[2]);
      nodes.push(url && interactive ? <a key={key} href={url} target="_blank" rel="noopener noreferrer">{m[1]}</a> : token);
    }
    cursor = regex.lastIndex;
  }
  if (cursor < text.length) nodes.push(<StreamText key={'text-' + cursor} text={text.slice(cursor)}/>);
  return nodes;
}

